export default class FieldSettings {
  constructor (options = {}, telehealth = false) {
    this.lastName = options.lastname ? new FieldSetting(options.lastname) : null
    this.firstName = options.firstname ? new FieldSetting(options.firstname) : null
    this.phone = options.phone ? new FieldSetting(options.phone) : null
    this.email = options.email ? new FieldSetting(options.email) : null
    this.dateOfBirth = options.date_of_birth ? new FieldSetting(options.date_of_birth) : null
    this.sex = options.sex ? new FieldSetting(options.sex) : null
    this.reason = options.reason ? new FieldSetting(options.reason) : null
    this.insuranceProviderId = options.insurance_provider_id ? new FieldSetting(options.insurance_provider_id) : null
    this.insuranceIdNumber = options.insurance_id_number ? new FieldSetting(options.insurance_id_number) : null
    this.insuranceGroupNumber = options.insurance_group_number ? new FieldSetting(options.insurance_group_number) : null
    this.insurancePhone = options.insurance_phone ? new FieldSetting(options.insurance_phone) : null
    this.comment = options.comment ? new FieldSetting(options.comment) : null
    this.referral = options.referral ? new FieldSetting(options.referral) : null
    this.ageVerification = options.age_verification ? new FieldSetting(options.age_verification) : null
    this.visitType = telehealth ? new FieldSetting({ required: true, hide: false }) : new FieldSetting({ required: false, hide: true })
  }
}

class FieldSetting {
  constructor (options) {
    this.step = options.step ?? null
    this.required = options.required ?? false
    this.hide = options.hide ?? false
  }
}
